import { motion } from 'framer-motion';
import React from 'react';

export default function MagentaLine(props) {
  const STYLE = {
    width: '2px',
    height: props.height,
    backgroundColor: '#c6158d',
    position: 'absolute',
    left: props.left,
    top: '0px',
    zIndex: '1000',
  };
  return (
    <motion.div
      initial={{ scaleY: 0, originY: 0, originX: 0.5 }}
      animate={{ scaleY: 1 }}
      transition={{ duration: 0.4, delay: 0.5 }}
      style={STYLE}
    />
  );
}
